/*
  Project: betaSense
  Author: schrittweiter GmbH
 */

import './modules/lazy'
import './modules/toggle'
import './modules/header'
import './modules/footer'
import './modules/slider'
import './modules/scroll'
import './modules/lightbox'
import './modules/accordion'
import './modules/teaser-card'
import './modules/video'
import './modules/timeline'
import './modules/sticky-section'
